import React from "react"
import Layout from "../components/layout"
import Message from "../components/Message"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import SEO from "../components/seo"
import contactStyles from "./contact.module.scss"

const ContactPage = () => {
  return (
    <Layout>
      <SEO title="Contact" />
      <Col className={`px-0 ${contactStyles.contactWrapper}`}>
        <section>
          <Col
            className="border mx-auto px-0 pb-lg-4 pb-xl-4 pb-md-4"
            xs={12}
            sm={12}
            md={10}
            lg={10}
            xl={10}
          >
            <Row
              className={`mx-0 py-4 border shadow ${contactStyles.contactFormArea}`}
            >
              <Col xs={12} sm={12} md={12} lg={6} xl={6} className="px-4">
                <h2>Contact Me</h2>
                <Form id="contactForm">
                  <Row className={contactStyles.contactLeft}>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={6}
                      xl={6}
                      className={`pl-0 pr-0 pr-sm-0 pr-md-0 pr-xl-2 pr-lg-2 pr-0`}
                    >
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder="Name"
                          required
                          data-error="Please enter your name"
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={6}
                      xl={6}
                      className="pr-0 pl-0 pl-sm-0 pl-md-0 pl-xl-2 pl-lg-2"
                    >
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Email"
                          id="email"
                          className="form-control"
                          name="email"
                          required
                          data-error="Please enter your email"
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="px-0"
                    >
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Subject"
                          id="msg_subject"
                          className="form-control"
                          required
                          data-error="Please enter your subject"
                        />
                        <div className="help-block with-errors"></div>
                      </div>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="px-0"
                    >
                      <div className="form-group">
                        <textarea
                          className="form-control"
                          id="message"
                          placeholder="Your Message"
                          rows="5"
                          data-error="Write your message"
                          required
                        ></textarea>
                        <div className="help-block with-errors"></div>
                      </div>
                      <div className="submit-button float-right">
                        <Button id="submit" type="submit">
                          Send Message
                        </Button>
                        <div
                          id="msgSubmit"
                          className="h3 text-center hidden"
                        ></div>
                        <div className="clearfix"></div>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                <h2>Contact Address</h2>
                <div className={`p-4 ${contactStyles.contactRight}`}>
                  <div className="single-contact">
                    <div className="contact-icon">
                      <i className="fa fa-map-marker"></i>
                    </div>
                    <p>London, UK</p>
                  </div>
                  <div className="single-contact">
                    <div className="contact-icon">
                      <i className="fa fa-envelope"></i>
                    </div>
                    <p>
                      <a href="mailto:webfabricsuk@gmail.com">
                        suncam123@gmail.com
                      </a>
                    </p>
                  </div>
                  <div className="single-contact">
                    <div className="contact-icon">
                      <i className="fa fa-phone"></i>
                    </div>
                    <p>
                      <a href="00447804610498">+ (0044) 780 461 0498</a>
                    </p>
                  </div>
                </div>
              </Col>
              <div className="col-md-12">
                <object
                  style={{
                    marginTop: "10px",
                    borderWidth: "1px",
                    borderColor: "#c7c7c7",
                    borderStyle: "solid",
                    boxShadow: "0 2px 6px #646464",
                    height: "450px",
                    width: "100%",
                  }}
                  aria-labelledby="map"
                  data="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2487.4848600952323!2d-0.17490558457996616!3d51.430888924116026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487605e27feccd2f%3A0xf7f76ea1e04ebfb!2s81+Broadwater+Rd%2C+Tooting%2C+London+SW17+0DY!5e0!3m2!1sen!2suk!4v1558385098628!5m2!1sen!2suk"
                ></object>
              </div>
            </Row>
          </Col>
        </section>
        <section>
          <Col
            className="pb-4 px-0 mx-auto"
            xs={12}
            sm={12}
            md={10}
            lg={10}
            xl={10}
          >
            <Message />
          </Col>
        </section>
      </Col>
    </Layout>
  )
}
export default ContactPage
